export default "<div style=\"margin: 10px 0px; border: 1px dashed #666;\"></div>";